export const HELPDESK_COMPONENT = '__helpdesk__';

const VIDEO_PAGES = [
    'video-mietkautionskonto',
    'video-mietkautionskonto-vergleich',
    'video-mietkautionskonto-kosten',
    'video-zinsen-bei-mietkautionskonten',
] as const;

/**
 * Inertia component name → public/pages JSON file(s).
 * Auth and dashboard pages are omitted; they load the app bundles instead.
 */
export const PUBLIC_COMPONENT_PAGES: Record<string, readonly string[]> = {
    welcome: ['home'],
    presse: ['presse'],
    'haus-und-grund': ['haus-und-grund', 'home'],
    'haus-und-grund-duesseldorf': ['haus-und-grund-duesseldorf', 'home'],
    immoscout24: ['immoscout24', 'home'],
    impressum: ['impressum'],
    datenschutz: ['datenschutz'],
    agb: ['agb'],
    help: ['help'],
    verbaende: ['verbaende'],
    'partner-kit': ['partner-kit', 'help'],
    'autor/robert-litwak': ['autor-robert-litwak'],
    'partner-landing': ['home'],
    'marketing-pages/video-playback': VIDEO_PAGES,
};

export type TranslationSpec = {
    publicPages: readonly string[];
    loadCommon: boolean;
    loadApp: boolean;
    loadHelpdesk: boolean;
};

export function isMarketingComponent(component: string): boolean {
    if (component.startsWith('error/') || component.startsWith('marketing-pages/')) {
        return true;
    }

    return component in PUBLIC_COMPONENT_PAGES;
}

export function translationSpecForComponent(component: string): TranslationSpec {
    if (component === HELPDESK_COMPONENT) {
        return { publicPages: [], loadCommon: true, loadApp: true, loadHelpdesk: true };
    }

    if (component.startsWith('error/') || component.startsWith('auth/')) {
        return { publicPages: [], loadCommon: true, loadApp: true, loadHelpdesk: false };
    }

    const mapped = PUBLIC_COMPONENT_PAGES[component];

    if (mapped) {
        return { publicPages: mapped, loadCommon: true, loadApp: false, loadHelpdesk: false };
    }

    if (component.startsWith('marketing-pages/')) {
        return {
            publicPages: [component.slice('marketing-pages/'.length)],
            loadCommon: true,
            loadApp: false,
            loadHelpdesk: false,
        };
    }

    return { publicPages: [], loadCommon: false, loadApp: true, loadHelpdesk: false };
}

export function resolveLocale(locale: string | undefined): 'de' | 'en' {
    return locale?.toLowerCase().startsWith('en') ? 'en' : 'de';
}

export function localeFromPageProps(page?: { props?: Record<string, unknown> }): string | undefined {
    const locale = page?.props?.locale;

    return typeof locale === 'string' ? locale : undefined;
}
